import * as PopoverPrimitive from "@radix-ui/react-popover";
import type { ReactNode } from "react";
import { cn } from "../lib/cn.ts";

/**
 * Mini janela do Ofative (View options, Search, change date/repeat).
 *
 * Radix cobre foco, Escape e posicionamento. A sombra vem dos effects do kit
 * (`--dream-shadow-menu`).
 */

export interface PopoverProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  trigger: ReactNode;
  children: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  sideOffset?: number;
  className?: string;
  /** Largura da janela. Padrão: 18rem, como os cards flutuantes do kit. */
  width?: string;
}

export function Popover({
  open,
  onOpenChange,
  trigger,
  children,
  side = "bottom",
  align = "end",
  sideOffset = 8,
  className,
  width,
}: PopoverProps) {
  return (
    <PopoverPrimitive.Root open={open} onOpenChange={onOpenChange} modal={false}>
      <PopoverPrimitive.Trigger asChild>{trigger}</PopoverPrimitive.Trigger>
      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
          side={side}
          align={align}
          sideOffset={sideOffset}
          collisionPadding={12}
          className={cn("dream-mini-window dream-popover-in z-[60] outline-none", className)}
          style={{ width: width ?? "min(18rem, calc(100vw - 1.5rem))" }}
        >
          {children}
        </PopoverPrimitive.Content>
      </PopoverPrimitive.Portal>
    </PopoverPrimitive.Root>
  );
}
